module.exports = __webpack_public_path__ + "static/media/iconDistribution.4d74926a.svg";